module.exports={versionNode:"2.0.0",versionOrds:"2.0.0-ords"};